import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'
import QuoteWidget from './QuoteWidget'

const ease = [0.16, 1, 0.3, 1]

export default function Hero() {
  const reduce = useReducedMotion()
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] })
  const imageY = useTransform(scrollYProgress, [0, 1], ['0%', '18%'])

  return (
    <section id="inicio" ref={ref} className="relative min-h-[100dvh] overflow-hidden bg-navy-950 text-white">
      <motion.div style={reduce ? undefined : { y: imageY }} className="absolute inset-0 will-change-transform">
        <img
          src="/Fondo.JPG"
          alt="Skyline al atardecer, uno de los destinos que conectamos desde Guatemala"
          className="size-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-r from-navy-950/80 via-navy-950/45 to-navy-950/10" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-navy-950/70 to-transparent" />

      <div className="relative mx-auto flex min-h-[100dvh] max-w-7xl flex-col justify-end px-4 pb-10 pt-28 md:px-8 md:pb-14">
        <motion.h1
          initial={reduce ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease }}
          className="max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl md:text-6xl"
        >
          Tu próxima aventura
          <br />
          <span className="text-sunset-500">empieza aquí.</span>
        </motion.h1>
        <motion.p
          initial={reduce ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease, delay: 0.08 }}
          className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:text-lg"
        >
          En <strong className="font-semibold text-white">Despega GT</strong> hacemos que viajar sea fácil, seguro y
          emocionante. Tours, paquetes, visas y pasaportes, cotizados por una persona real en menos de 24 horas.
        </motion.p>

        <motion.div
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease, delay: 0.16 }}
          className="mt-8"
        >
          <QuoteWidget />
        </motion.div>
      </div>
    </section>
  )
}
